//This is the white bar that goes the width of the screen and let's you select a current league
import React, { useState, useEffect } from 'react'
import Card from './Card'
import './SelectLeague.css'
import { useNavigate } from 'react-router-dom'
//import LeagueDatabaseTable from '../LeagueDatabaseTable'

const SelectLeagueForScoringLeaders = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedLeagues, setLoadedLeagues] = useState()
	const [leaguesNoDuplicates, setLeaguesNoDuplicates] = useState()
	const [error, setError] = useState()
	let selectedLeague

	//Call backend to get all the current leagues for our dropdown
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedLeagues(responseData.currentLeagues)
				setLeaguesNoDuplicates(responseData.currentLeaguesSortedNoDuplicates)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [setLoadedLeagues, setLeaguesNoDuplicates])

	//console.log('currentLeagues: ' + JSON.stringify(loadedLeagues))

	let leagueArray, leaguesNoDuplicatesArray

	/* if (loadedLeagues && !isLoading) {
		leagueArray = []
		loadedLeagues.forEach((league) => {
			const leagueDisplay =
				league.leagueName +
				(league.divisionName && ' - ' + league.divisionName + ' DIVISION') +
				' - ' +
				league.session +
				' ' +
				league.year
			leagueArray.push(leagueDisplay)
		})
	} */
	//
	//
	//
	if (leaguesNoDuplicates && !isLoading) {
		leaguesNoDuplicatesArray = []
		leaguesNoDuplicates.forEach((league) => {
			const leagueDisplay =
				league.leagueName +
				//(league.divisionName && ' - ' + league.divisionName + ' DIVISION') +
				//' - ' +
				//league.session +
				' - ' +
				league.year
			leaguesNoDuplicatesArray.push(leagueDisplay)
		})
	}

	let navigate = useNavigate()

	const handleChange = (e) => {
		if (e.target.value === 'VIEW PREVIOUS TOURNAMENTS') {
			//console.log('you wish to view previous leagues')
			navigate('/league/previousLeagues') //< - - This changes the url
		} else if (e.target.value !== 'Select Tournament....') {
			e.preventDefault()
			const selectedValue = e.target.value
			//console.log(selectedValue)
			selectedLeague = leaguesNoDuplicates[selectedValue]
			const leagueId = selectedLeague._id
			navigate(`/league/scoring/${leagueId}`) //< - - This navigates to show the scoring leaders
		}
	}

	return (
		<React.Fragment>
			<Card>
				{!isLoading && leaguesNoDuplicates && (
					<form className='form-control-lg'>
						<select
							className='selector my-1 mr-sm-2 selectLeagueDropdown'
							onChange={handleChange}
						>
							<option defaultValue>Select Tournament....</option>
							{leaguesNoDuplicatesArray.map((league, i) => (
								<option value={i} key={i}>
									{league.toUpperCase()}
								</option>
							))}
							<option style={{ background: '#b42328' }}>
								VIEW PREVIOUS TOURNAMENTS
							</option>
						</select>
					</form>
				)}
			</Card>
		</React.Fragment>
	)
}

export default SelectLeagueForScoringLeaders
